// Дизайн-токени Speaksy. Нові екрани беруть кольори, радіуси й тіні тільки звідси —
// так редизайн усієї платформи зведеться до заміни значень у цьому файлі.
// Палітра зібрана навколо фірмових кольорів платформи: бузково-синій і бурштиновий.

export const colors = {
  bg: "#F7F6FD",
  surface: "#FFFFFF",
  ink: "#1E1B3A",
  muted: "#6E6A8A",
  line: "#E7E5F5",

  brand: "#7B78E8",
  brandDeep: "#5652D4",
  brandDark: "#2B2766",
  brandSoft: "#EEEDFF",

  amber: "#F4B63F",
  amberDeep: "#D9951A",
  amberSoft: "#FFF4DC",

  pink: "#F06A9B",
  pinkSoft: "#FFE9F1",

  success: "#17A06A",
  successSoft: "#E3F6EC",
  danger: "#D6455D",
  dangerSoft: "#FDE9EC",
};

export const font = {
  text: "'Manrope', system-ui, -apple-system, 'Segoe UI', sans-serif",
};

export const radius = {
  sm: "10px",
  md: "14px",
  lg: "20px",
  xl: "28px",
  pill: "999px",
};

export const shadow = {
  card: "0 1px 2px rgba(30, 27, 58, 0.04), 0 8px 24px rgba(30, 27, 58, 0.06)",
  raised: "0 12px 32px rgba(43, 39, 102, 0.18)",
  // «Натискна» кнопка: нижній край як у фізичної кнопки
  button: (color) => `0 4px 0 ${color}`,
};
